module.exports = __webpack_public_path__ + "img/DW365-115.1fcd3ee8.jpg";